export default __webpack_public_path__ + "static/media/img_study_log.dab6e3ff.svg";